import "./Products.scss";
import { VacancyProductsComponent_Plain } from "../../../types/components/page/VacancyProductsComponent.ts";
import { getStrapiMedia } from "../../../utils/utils.tsx";
import { useState } from "react";

const Products = ({ data }: { data: VacancyProductsComponent_Plain }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <section className="career-products">
        <div className="wrapper">
          <h2>
            {data.title1}
            <span>{data.title2}</span>
          </h2>

          <div className="career-products__cont">
            <div className="block-title">{data.subTitle}</div>
            <ul className="career-products-list">
              {data.products.map((product, index) => (
                <li
                  className="career-products-list__item"
                  key={index}
                  onMouseEnter={() => setActiveIndex(index)}
                >
                  <div className="career-products-list__name">
                    {product.name}
                  </div>
                  <div className="career-products-list__icon">
                    {product.icon ? (
                      <img src={getStrapiMedia(product.icon.url)} />
                    ) : (
                      ""
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="career-products__img">
            {data.products.map((product, index) =>
              product.backgound ? (
                <img
                  key={index}
                  src={getStrapiMedia(product.backgound.url)}
                  className={index === activeIndex ? "active" : ""}
                  width="1380"
                  height="348"
                  alt={product.name}
                />
              ) : null,
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
